__turbopack_context__.v({
  "avatar": "FolderTable-module__AEIHqG__avatar",
  "caretIcon": "FolderTable-module__AEIHqG__caretIcon",
  "folderTable": "FolderTable-module__AEIHqG__folderTable",
  "iconButtonCell": "FolderTable-module__AEIHqG__iconButtonCell",
});
